import {useState} from "react";

import CCPPanel from "./components/CCPPanel/CCPPanel";
import Header from "./components/Header/Header";

const App = () => {
  const [agentInfo, setAgentInfo] = useState();
  const [agentQueues, setAgentQueues] = useState();
  const [logoutAgent, setLogoutAgent] = useState(false);
  const [outboundCallInfo, setOutboundCallInfo] = useState();

  const handleLogout = () => {
    setAgentInfo();
    setLogoutAgent(true);
  };

  const agentInfoHandler = (agent) => {
    // console.log("App.js - Received Agent Info:", JSON.stringify(agent));
    setAgentInfo(agent);
  };

  const agentQueuesHandler = (queues) => {
    setAgentQueues(queues);
  };

  const outboundCallHandler = (countryCode, phoneNumber, queueId) => {
    console.log(
      `Outbound call to ${countryCode}${phoneNumber} via queue ${queueId}`
    );
    setOutboundCallInfo({countryCode, phoneNumber, queueId});
  };

  return (
    <div className="flex flex-col h-full bg-gray-100">
      <Header
        onLogout={handleLogout}
        agentInfo={agentInfo}
        agentQueues={agentQueues}
        onOutbound={outboundCallHandler}
      />
      <section className="flex mt-15 w-full h-screen">
        <CCPPanel
          agentInfo={agentInfoHandler}
          agentQueues={agentQueuesHandler}
          logoutAgent={logoutAgent}
          outboundCall={outboundCallInfo}
        />
      </section>
    </div>
  );
};

export default App;
